import * as React from 'react';
import { withEmptyRendering } from '../../utils/hoc/withEmptyRendering';
import * as styles from './Brief.css';

interface IBriefProps {
  label: React.ReactNode;
  value: React.ReactNode;
}

export function BriefComponent({ label, value }: IBriefProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['label']}>{label}</div>
      <div className={styles['value']}>{value}</div>
    </div>
  );
}

export function shouldRenderBrief(props: IBriefProps) {
  return !props.label;
}

export const Brief = withEmptyRendering<IBriefProps>(shouldRenderBrief)(BriefComponent);
